const welcomeKey = username => `kelimoNotificationWelcome:${username}`;
const playedKey = username => `kelimoNotificationGamePlayed:${username}`;
const WEEK = 7 * 86400000;
function markGamePlayed(storage,username) { try { storage.setItem(playedKey(username),'1'); } catch {} }
function hasPlayed(storage,username,played=false) { try { return Boolean(played || storage.getItem(playedKey(username)) === '1'); } catch { return false; } }
function shouldOfferNotifications(storage, username, status, options = {}) {
 if (!username || !status?.available || status.disabled || !hasPlayed(storage,username,options.played) || status.enabled && options.remindersConfigured || !['default','granted'].includes(status.permissionState)) return false;
 try {
  if (storage.getItem(`kelimoPushDisabled:${username}`)==='1' || storage.getItem(`kelimoNativePushDisabled:${username}`)==='1') return false;
  const raw=storage.getItem(welcomeKey(username)), now=options.now ?? Date.now();
  if (!raw) return true;
  let saved; try { saved=JSON.parse(raw); } catch { rememberNotificationChoice(storage,username,'later',now); return false; }
  return typeof saved.nextAt==='number' && now>=saved.nextAt;
 } catch { return false; }
}
function rememberNotificationChoice(storage, username, choice, now=Date.now()) {
 try { storage.setItem(welcomeKey(username),JSON.stringify({choice,at:now,nextAt:now+WEEK})); } catch {}
}
module.exports = { shouldOfferNotifications, rememberNotificationChoice, markGamePlayed, hasPlayed, WEEK };
